export default "__VITE_ASSET__BAMj25YL__"